import { combineReducers, Reducer, CombinedState } from 'redux';
import productsReducerSlice from './products';
import checkoutReducerSlice from './checkout';
import { initialState as initialStateProducts } from './products';
import { initialState as initialStateCheckout } from './checkout';
import { IProductManagementState } from './type';

export const initialProductManagementState = {
    products: initialStateProducts,
    checkout: initialStateCheckout,
};

const productManagementReducer: Reducer<CombinedState<IProductManagementState>> = combineReducers({
    products: productsReducerSlice,
    checkout: checkoutReducerSlice,
});

export default productManagementReducer;
